export default __webpack_public_path__ + "static/media/UVSensorImg.edc9a1db.jpg";